var map = {
	"./1936.svg": [
		9687,
		687
	],
	"./1937.svg": [
		2566,
		566
	],
	"./1938.svg": [
		5361,
		361
	],
	"./1939.svg": [
		3120,
		120
	],
	"./1942.svg": [
		7590,
		590
	],
	"./1948.svg": [
		6508,
		508
	],
	"./1950.svg": [
		6727,
		727
	],
	"./1974.svg": [
		2049,
		49
	],
	"./1977.svg": [
		1682,
		682
	],
	"./1978.svg": [
		6325,
		325
	],
	"./1979.svg": [
		5156,
		156
	],
	"./1983.svg": [
		9467,
		467
	],
	"./2003.svg": [
		7923,
		923
	],
	"./2005.svg": [
		4893,
		893
	],
	"./2007.svg": [
		8671,
		671
	],
	"./2008.svg": [
		6696,
		696
	],
	"./2013.svg": [
		8704,
		704
	],
	"./2014.svg": [
		6175,
		175
	],
	"./2015.svg": [
		5182,
		182
	],
	"./2016.svg": [
		4509,
		509
	],
	"./2019.svg": [
		154,
		154
	],
	"./bg-titol-primary.svg": [
		7075,
		75
	],
	"./bg-titol.svg": [
		7494,
		494
	],
	"./hover-any-menu.svg": [
		9279,
		279
	],
	"./hover-boto-mapa-2.svg": [
		2370,
		370
	],
	"./hover-boto-mapa.svg": [
		6855,
		855
	],
	"./ico-anterior.svg": [
		5062,
		62
	],
	"./ico-mapa.svg": [
		5813,
		813
	],
	"./ico-menys.svg": [
		5650,
		650
	],
	"./ico-mes.svg": [
		635,
		635
	],
	"./ico-seguent.svg": [
		9993,
		993
	],
	"./logo-expo-euskera.svg": [
		917,
		917
	],
	"./logo-expo.svg": [
		8056,
		56
	],
	"./skull-fuchsia.svg": [
		4565,
		565
	],
	"./skull.svg": [
		9733,
		733
	],
	"./titol-ambit1.svg": [
		4269,
		269
	],
	"./titol-ambit2.svg": [
		3550,
		550
	],
	"./titol-ambit3.svg": [
		1487,
		487
	],
	"./titular-expo-euskera.svg": [
		7349,
		349
	],
	"./titular-expo-mobile-euskera.svg": [
		2262,
		262
	],
	"./titular-expo-mobile.svg": [
		9595,
		595
	],
	"./titular-expo.svg": [
		8488,
		488
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 492;
module.exports = webpackAsyncContext;